import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OrderRepository from "../../../repository/OrderRepository";
import { __remove, __set } from "../../axios_indicator";

export const fetchOrderList = createAsyncThunk('order_fetchOrderList', async (params) => {
    __set('ORDER_API_CALL');
    return await new OrderRepository().fetchOrderList(params)
});


export const fetchPlaceOrderItems = createAsyncThunk('order_fetchPlaceOrderItems', async (params) => {
    return await new OrderRepository().fetchPlaceOrderItems(params)
});
export const fetchExportOrderCount = createAsyncThunk('order_fetchExportOrderCount', async (params) => {
    __set('ORDER_EXPORT_COUNT_API_CALL');
    return await new OrderRepository().fetchOrderExportCount(params);
});

export const fetchManufacturerList = createAsyncThunk('order_fetchManufacturerList', async (params) => {
    return await new OrderRepository().fetchManufacturerList(params);
});
export const getValidateOrderFromServer = createAsyncThunk('order_fetchValidateOrderFromServer', async (params) => {
    __set('VALIDATE_ORDER_API_CALL');
    return await new OrderRepository().getValidateOrderFromServer(params);
});
export const fetchOrderDetail = createAsyncThunk('order_getDetail', async (params) => {
    __set('GET_ORDER_DETAIL');
    return await new OrderRepository().fetchOrderDetail(params);
});

export const fetchProductSpecificDetails = createAsyncThunk('product_specific_details', async (params) => {
    __set('GET_ORDER_DETAIL');
    return await new OrderRepository().fetchProductSpecificDetails(params);
});

const initialState = {
    orderList: {},
    placeOrderItemList: {},
    placeOrderLoading: false,
    orderExportCount: 0,
    orderManuFactureList: [],
    orderParams: {},
    orderDetail: {},
    productSpecificDetails: [],
};
const slice = createSlice({
    name: "Order",
    initialState: initialState,
    reducers: {
        setPlaceOrderLoading: {
            reducer: (state, action) => {
                state.placeOrderLoading = action.payload
            }
        },
        setOrderParams: {
            reducer: (state, action) => {
                state.orderParams = action.payload
            }
        }
    },
    extraReducers: {
        [fetchOrderList.fulfilled]: (state, { payload }) => {
            state.orderList = payload;
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
            return state;
        },
        [fetchOrderList.rejected]: (state, { payload }) => {
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
        },
        [getValidateOrderFromServer.fulfilled]: (state, { payload }) => {
            state.validateOrderFromServer = payload;
            __remove('VALIDATE_ORDER_API_CALL');

            return state;
        },
        [getValidateOrderFromServer.rejected]: (state, { payload }) => {
            __remove('VALIDATE_ORDER_API_CALL');

        },
        [fetchPlaceOrderItems.fulfilled]: (state, { payload }) => {
            state.placeOrderItemList = payload;
            return state
        },
        [fetchPlaceOrderItems.rejected]: (state, { payload }) => {
        },
        [fetchExportOrderCount.fulfilled]: (state, { payload }) => {

            state.orderExportCount = payload;
            __remove('ORDER_EXPORT_COUNT_API_CALL');
        },
        [fetchExportOrderCount.rejected]: (state, { payload }) => {
            __remove('ORDER_EXPORT_COUNT_API_CALL');
        },
        [fetchManufacturerList.fulfilled]: (state, { payload }) => {
            state.orderManuFactureList = payload;
            return state;
        },
        [fetchManufacturerList.rejected]: (state, { payload }) => {

        },
        [fetchOrderDetail.fulfilled]: (state, { payload }) => {
            state.orderDetail = payload;
            __remove('GET_ORDER_DETAIL');
        },
        [fetchOrderDetail.rejected]: (state, { payload }) => {
            __remove('GET_ORDER_DETAIL');
        },
        [fetchProductSpecificDetails.fulfilled]: (state, { payload }) => {
            state.productSpecificDetails = payload;
            __remove('GET_PRODUCT_SPECIFIC_DETAILS');
        },
        [fetchProductSpecificDetails.rejected]: (state, { payload }) => {
            __remove('GET_PRODUCT_SPECIFIC_DETAILS');
        },
    },
});

export let { setPlaceOrderLoading, setOrderParams } = slice.actions;

export default slice.reducer;
